import { ApolloClient, from, NormalizedCacheObject } from '@apollo/client';
import {
  createUploadHttpLink,
  buildAuthErrorLink,
  authLink,
  userCountryLink,
  getApolloDevtoolsOptions,
} from '@blocs.auth';
import cache from './cache';
import { INIT_CACHE_STATE, BASE_CONFIG } from './config';

function createApolloClient(): ApolloClient<NormalizedCacheObject> {
  const client = new ApolloClient({
    // base config includes defaultOptions and resolvers
    ...BASE_CONFIG(),
    link: from([buildAuthErrorLink({}), userCountryLink, authLink, createUploadHttpLink()]),
    cache,
    name: 'web',
    version: 'talent',
    devtools: getApolloDevtoolsOptions(),
  });

  INIT_CACHE_STATE(cache);

  return client;
}

export default createApolloClient;
